module.exports = __webpack_public_path__ + "static/media/sc37.41.98b0e684.mp4";